import { render, staticRenderFns } from "./vehicles.select.vue?vue&type=template&id=609512cb"
import script from "./vehicles.select.vue?vue&type=script&lang=js"
export * from "./vehicles.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports